(function () {
  'use strict';

  // Debug log — check via: JSON.stringify(window._looxDbg) in browser console
  window._looxDbg = [];
  function dbg(m) { window._looxDbg.push(m); }

  // Returns true if el has no block-level children (safe to apply line-clamp)
  function isLeaf(el) {
    var BLOCKS = { P:1, DIV:1, SECTION:1, ARTICLE:1, H1:1, H2:1, H3:1,
                   H4:1, H5:1, H6:1, UL:1, OL:1, LI:1, TABLE:1, BLOCKQUOTE:1 };
    for (var i = 0; i < el.children.length; i++) {
      if (BLOCKS[el.children[i].tagName]) return false;
    }
    return true;
  }

  function doTrunc(el) {
    if (el._lx) return;
    var lh = parseFloat(window.getComputedStyle(el).lineHeight) || 22;
    var h = el.scrollHeight;
    dbg('cand tag=' + el.tagName + ' cls="' + el.className.slice(0,40) +
        '" h=' + h + ' lh=' + lh + ' txt=' + el.textContent.trim().slice(0,30));
    if (h <= lh * 2.4) { dbg('->skip(short)'); return; }

    el._lx = true;
    // Use setProperty with 'important' to override any Loox CSS
    el.style.setProperty('display', '-webkit-box', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    el.style.setProperty('-webkit-line-clamp', '2', 'important');
    el.style.setProperty('-webkit-box-orient', 'vertical', 'important');
    dbg('->TRUNCATED');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Read more';
    btn.className = 'loox-read-more';
    btn.style.cssText = 'display:block;margin-top:6px;padding:0;background:none;' +
      'border:none;cursor:pointer;color:#888;font-size:13px;' +
      'text-decoration:underline;line-height:1.4;';

    var open = false;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      open = !open;
      el.style.setProperty('-webkit-line-clamp', open ? 'unset' : '2', 'important');
      el.style.setProperty('display', open ? 'block' : '-webkit-box', 'important');
      btn.textContent = open ? 'Show less' : 'Read more';
    });
    el.insertAdjacentElement('afterend', btn);
  }

  function scan() {
    dbg('scan t=' + Date.now());

    // Pass 1: named CSS class/attribute selectors
    [
      '[class*="ReviewBody"]', '[class*="reviewBody"]', '[class*="review-body"]',
      '[class*="ReviewText"]', '[class*="reviewText"]', '[class*="review_body"]',
      '[class*="review_text"]', '[class*="Body_"]', '[class*="body_"]',
      '[class*="reviewContent"]', '[class*="ReviewContent"]',
      '[data-hook="review-body"]', '[data-testid="review-body"]',
      '[data-loox="body"]', '.loox-review__body', '.loox-review-body'
    ].forEach(function (s) {
      try {
        document.querySelectorAll(s).forEach(function (el) {
          if (el.textContent.trim().length > 50) doTrunc(el);
        });
      } catch (e) { dbg('sel err:' + s); }
    });

    // Pass 2: brute-force inside every possible Loox container
    [
      '#loox', '#loox-widget', '[id^="loox"]', '[id*="loox"]',
      '[class*="loox"]', '[class*="Loox"]', '.shopify-app-block',
      '[data-loox]', '[data-loox-widget]'
    ].forEach(function (cs) {
      try {
        document.querySelectorAll(cs).forEach(function (root) {
          dbg('container ' + cs + ' kids=' + root.children.length);
          root.querySelectorAll('p, span, div').forEach(function (el) {
            if (el._lx) return;
            if (el.textContent.trim().length < 80) return;
            if (!isLeaf(el)) return;
            doTrunc(el);
          });
        });
      } catch (e) { dbg('container err:' + cs); }
    });
  }

  // Debounced MutationObserver
  var obs = new MutationObserver(function () {
    clearTimeout(obs._t);
    obs._t = setTimeout(scan, 250);
  });

  function init() {
    dbg('init');
    obs.observe(document.body, { childList: true, subtree: true });
    // Retry every 600 ms for 20 iterations (12 s window)
    var n = 0;
    (function tick() { scan(); if (++n < 20) setTimeout(tick, 600); })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
